import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import { saveGiveaway, listCategories } from '../../common/api';
function toLocalInput(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = n => String(n).padStart(2, '0');
  return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), "T").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()));
}
function toIso(local) {
  if (!local) return null;
  const d = new Date(local);
  return isNaN(d.getTime()) ? null : d.toISOString();
}
export default class GiveawayFormModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "titleInput", void 0);
    _defineProperty(this, "prize", void 0);
    _defineProperty(this, "description", void 0);
    _defineProperty(this, "coverUrl", void 0);
    _defineProperty(this, "endsAt", void 0);
    _defineProperty(this, "startsAt", void 0);
    _defineProperty(this, "winnerCount", void 0);
    _defineProperty(this, "postBonus", void 0);
    _defineProperty(this, "minPosts", void 0);
    _defineProperty(this, "minAgeDays", void 0);
    _defineProperty(this, "categoryId", void 0);
    _defineProperty(this, "claimInstructions", void 0);
    _defineProperty(this, "categories", []);
  }
  oninit(vnode) {
    var _g$category;
    super.oninit(vnode);
    const g = this.attrs.giveaway;
    this.categories = this.attrs.categories || [];
    if (!this.categories.length) {
      listCategories().then(res => {
        this.categories = res.data || [];
        m.redraw();
      });
    }
    this.categoryId = Stream((g == null || (_g$category = g.category) == null ? void 0 : _g$category.id) || 0);
    this.claimInstructions = Stream((g == null ? void 0 : g.claimInstructions) || '');
    this.titleInput = Stream((g == null ? void 0 : g.title) || '');
    this.prize = Stream((g == null ? void 0 : g.prize) || '');
    this.description = Stream((g == null ? void 0 : g.description) || '');
    this.coverUrl = Stream((g == null ? void 0 : g.coverUrl) || '');
    this.endsAt = Stream(toLocalInput(g == null ? void 0 : g.endsAt));
    this.startsAt = Stream(toLocalInput(g == null ? void 0 : g.startsAt));
    this.winnerCount = Stream((g == null ? void 0 : g.winnerCount) || 1);
    this.postBonus = Stream((g == null ? void 0 : g.postBonus) || 0);
    this.minPosts = Stream((g == null ? void 0 : g.minPosts) || 0);
    this.minAgeDays = Stream((g == null ? void 0 : g.minAgeDays) || 0);
  }
  className() {
    return 'GiveawayFormModal Modal--large';
  }
  title() {
    return this.attrs.giveaway ? app.translator.trans('ernestdefoe-giveaways.forum.edit') : app.translator.trans('ernestdefoe-giveaways.forum.create');
  }
  content() {
    const t = k => app.translator.trans('ernestdefoe-giveaways.forum.form.' + k);
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form"
    }, this.field(t('title_label'), m("input", {
      className: "FormControl",
      value: this.titleInput(),
      placeholder: t('title_placeholder'),
      oninput: e => this.titleInput(e.target.value)
    })), this.field(t('prize_label'), m("input", {
      className: "FormControl",
      value: this.prize(),
      placeholder: t('prize_placeholder'),
      oninput: e => this.prize(e.target.value)
    })), this.field(t('description_label'), m("textarea", {
      className: "FormControl",
      rows: 4,
      value: this.description(),
      placeholder: t('description_placeholder'),
      oninput: e => this.description(e.target.value)
    })), this.field(t('cover_label'), m("input", {
      className: "FormControl",
      value: this.coverUrl(),
      placeholder: t('cover_placeholder'),
      oninput: e => this.coverUrl(e.target.value)
    })), this.categories.length > 0 && this.field(t('category_label'), m("select", {
      className: "FormControl",
      value: this.categoryId(),
      onchange: e => this.categoryId(parseInt(e.target.value, 10) || 0)
    }, m("option", {
      value: 0
    }, t('category_none')), this.categories.map(c => m("option", {
      value: c.id,
      selected: this.categoryId() === c.id
    }, c.name)))), m("div", {
      className: "GiveawayFormModal-row"
    }, this.field(t('starts_label'), m("input", {
      type: "datetime-local",
      className: "FormControl",
      value: this.startsAt(),
      oninput: e => this.startsAt(e.target.value)
    })), this.field(t('ends_label'), m("input", {
      type: "datetime-local",
      className: "FormControl",
      value: this.endsAt(),
      oninput: e => this.endsAt(e.target.value)
    }))), m("div", {
      className: "GiveawayFormModal-row"
    }, this.numberField(t('winner_count_label'), this.winnerCount, 1), this.numberField(t('post_bonus_label'), this.postBonus, 0, t('post_bonus_help'))), m("div", {
      className: "GiveawayFormModal-row"
    }, this.numberField(t('min_posts_label'), this.minPosts, 0), this.numberField(t('min_age_label'), this.minAgeDays, 0)), this.field(t('claim_label'), m("textarea", {
      className: "FormControl",
      rows: 3,
      value: this.claimInstructions(),
      placeholder: t('claim_placeholder'),
      oninput: e => this.claimInstructions(e.target.value)
    }), t('claim_help')), m("div", {
      className: "Form-group"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading
    }, t('submit')))));
  }
  field(label, control, help) {
    return m("div", {
      className: "Form-group"
    }, m("label", null, label), control, help && m("p", {
      className: "helpText"
    }, help));
  }
  numberField(label, stream, min, help) {
    return m("div", {
      className: "Form-group"
    }, m("label", null, label), m("input", {
      type: "number",
      className: "FormControl",
      min: min,
      value: stream(),
      oninput: e => stream(parseInt(e.target.value, 10) || 0)
    }), help && m("p", {
      className: "helpText"
    }, help));
  }
  onsubmit(e) {
    var _this$attrs$giveaway;
    e.preventDefault();
    this.loading = true;
    const attrs = {
      title: this.titleInput(),
      prize: this.prize(),
      description: this.description(),
      coverUrl: this.coverUrl(),
      endsAt: toIso(this.endsAt()),
      startsAt: toIso(this.startsAt()),
      winnerCount: this.winnerCount(),
      postBonus: this.postBonus(),
      minPosts: this.minPosts(),
      minAgeDays: this.minAgeDays(),
      categoryId: this.categoryId() || null,
      claimInstructions: this.claimInstructions()
    };
    saveGiveaway(attrs, (_this$attrs$giveaway = this.attrs.giveaway) == null ? void 0 : _this$attrs$giveaway.id).then(() => {
      var _this$attrs$onsave, _this$attrs;
      this.loading = false;
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('ernestdefoe-giveaways.forum.saved'));
      this.hide();
      (_this$attrs$onsave = (_this$attrs = this.attrs).onsave) == null || _this$attrs$onsave.call(_this$attrs);
    }).catch(err => {
      this.loading = false;
      this.onerror(err);
    });
  }
}
flarum.reg.add('ernestdefoe-giveaways', 'forum/components/GiveawayFormModal', GiveawayFormModal);